/* Calmmumma Little Landing v3.0.0 - small, dependency-free progressive enhancement. */
(function () {
  'use strict';

  // Mobile navigation stays usable with or without JavaScript.
  document.querySelectorAll('[data-menu-toggle]').forEach(function (button) {
    var nav = document.getElementById(button.getAttribute('aria-controls'));
    if (!nav) return;
    function setOpen(open) {
      button.setAttribute('aria-expanded', String(open));
      button.setAttribute('aria-label', open ? 'Close navigation' : 'Open navigation');
      nav.classList.toggle('is-open', open);
      nav.setAttribute('aria-hidden', String(!open));
      if (open) {
        var firstLink = nav.querySelector('a');
        if (firstLink) firstLink.focus({ preventScroll: true });
      }
    }
    setOpen(false);
    button.addEventListener('click', function () { setOpen(button.getAttribute('aria-expanded') !== 'true'); });
    nav.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') { setOpen(false); button.focus({ preventScroll: true }); }
    });
    nav.addEventListener('click', function (event) {
      if (event.target.closest('a')) setOpen(false);
    });
  });

  // Product option changes update price, comparison price and purchase availability in the same product panel.
  document.querySelectorAll('[data-variant-select]').forEach(function (select) {
    var info = select.closest('.product-info') || select.closest('.product-layout') || document;
    var price = info.querySelector('[data-current-price]');
    var compare = info.querySelector('[data-compare-price]');
    var button = info.querySelector('[data-add-button]');
    function update() {
      var option = select.options[select.selectedIndex];
      if (!option) return;
      if (price && option.dataset.price) price.textContent = option.dataset.price;
      if (compare) {
        var cents = Number(option.dataset.priceCents || 0);
        var compareCents = Number(option.dataset.compareCents || 0);
        if (option.dataset.compare && compareCents > cents) {
          compare.textContent = option.dataset.compare;
          compare.hidden = false;
        } else compare.hidden = true;
      }
      if (button) {
        var available = option.dataset.available === 'true';
        button.disabled = !available;
        button.textContent = available ? button.dataset.availableLabel : button.dataset.soldOutLabel;
      }
    }
    select.addEventListener('change', update);
    update();
  });

  document.querySelectorAll('[data-qty-decrease], [data-qty-increase]').forEach(function (button) {
    button.addEventListener('click', function () {
      var field = button.parentElement.querySelector('input[type="number"]');
      if (!field) return;
      var value = parseInt(field.value || '1', 10);
      field.value = String(Math.max(1, value + (button.hasAttribute('data-qty-increase') ? 1 : -1)));
      field.dispatchEvent(new Event('change', { bubbles: true }));
    });
  });

  // Product gallery swaps the main source and accessible description when a thumb is chosen.
  document.querySelectorAll('[data-gallery]').forEach(function (gallery) {
    var main = gallery.querySelector('.product-gallery__main img');
    if (!main) return;
    gallery.querySelectorAll('[data-gallery-thumb]').forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var img = thumb.querySelector('img');
        if (!img) return;
        main.src = thumb.dataset.fullSrc || img.currentSrc || img.src;
        main.removeAttribute('srcset');
        main.alt = thumb.dataset.alt || img.alt || '';
        gallery.querySelectorAll('[data-gallery-thumb]').forEach(function (item) {
          item.setAttribute('aria-pressed', String(item === thumb));
        });
      });
    });
  });

  // Guide finder does not save the chosen topic or send it anywhere.
  document.querySelectorAll('[data-guide-finder]').forEach(function (finder) {
    var choices = finder.querySelectorAll('[data-finder-choice]');
    var results = finder.querySelectorAll('[data-finder-result]');
    var status = finder.querySelector('[data-finder-status]');
    choices.forEach(function (choice) {
      choice.addEventListener('click', function () {
        var topic = choice.getAttribute('data-finder-choice');
        var matches = 0;
        choices.forEach(function (item) { item.setAttribute('aria-pressed', String(item === choice)); });
        results.forEach(function (card) {
          var match = card.getAttribute('data-finder-result') === topic;
          card.hidden = !match;
          if (match) matches += 1;
        });
        if (status) status.textContent = matches ? 'Here is a place to begin. You can explore it now or choose another topic.' : 'Browse the topics below for another place to start.';
      });
    });
  });

  // Product recommendations are optional and never block the product form.
  document.querySelectorAll('product-recommendations[data-url]').forEach(function (element) {
    var url = element.dataset.url;
    if (!url || element.dataset.loaded === 'true') return;
    element.dataset.loaded = 'true';
    fetch(url, { credentials: 'same-origin' })
      .then(function (response) { if (!response.ok) throw new Error('Recommendations unavailable'); return response.text(); })
      .then(function (markup) {
        var doc = document.createElement('div'); doc.innerHTML = markup;
        var source = doc.querySelector('product-recommendations');
        if (source && source.innerHTML.trim()) element.innerHTML = source.innerHTML;
      }).catch(function () { /* Optional enhancement: keep the rest of the page usable. */ });
  });

  // Submission guard is only attached where a form explicitly opts into it.
  document.querySelectorAll('form[data-disable-on-submit]').forEach(function (form) {
    form.addEventListener('submit', function () {
      var submit = form.querySelector('[type="submit"]');
      if (submit && !submit.disabled) {
        submit.disabled = true;
        submit.setAttribute('aria-busy', 'true');
        submit.dataset.originalLabel = submit.textContent;
        submit.textContent = submit.dataset.loadingLabel || 'Please wait…';
      }
    });
  });
}());
